<template>
  <button type="is-primary" class="button">
    <span @mouseover="exporter()">
      <download-excel
        :fetch="createCSV"
        :fields="json_fields"
        v-bind:name="csv_meeting_name + '.xls'"
      >
        <b-icon pack="fas" icon="file-excel"/>
     <span>{{' '}}{{$t("meeting.exporter_xls")}}</span>
      </download-excel>
    </span>
  </button>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import downloadExcel from "vue-json-excel";

export default {
  data() {
    return {
      csv_id: null,
      csv_url_moderateur: null,
      csv_meeting_name: null,
      json_fields: {
        Numéro: "numero",
        Question: "question"
      }
    };
  },
  computed: {
    ...mapGetters(["modalExportExcelPdf"])
  },
  components: {
    downloadExcel
  },
  methods: {
    exporter() {
      this.csv_id = this.modalExportExcelPdf.meetingId;
      this.csv_url_moderateur = this.modalExportExcelPdf.urlModerateur;
      this.csv_meeting_name = this.modalExportExcelPdf.meetingName;
    },
    async createCSV() {
      axios.defaults.headers.common["urlmoderateur"] = this.csv_url_moderateur;
      const response = await axios.get(
        process.env.URL_SSO_API +
          "textit/public/meeting/" +
          this.csv_id +
          "/question"
      );
      var json_fields = [];
      response.data.forEach(function(element, index) {
        var numQuestion = parseInt(index) + 1;
        var question = {
          numero: numQuestion,
          question: element.question
        };
        json_fields.push(question);
      });

      if (json_fields.length) {
        return json_fields;
      } else {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.pas_de_questions")
        });
      }
    }
  }
};
</script>

<style scoped>
.button {
  background: #424a60 !important;
  color:white;
  border-radius: 0px;
  font-size: 12px;
  width: 150px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/adminPage/components/ExportCSVButton.vue